import { createApiModule, createFetchReducer } from 'hooks';
export const MY_LIMITS_MODULE_NAME = 'myLimits';
const createApiModuleActions = createApiModule(MY_LIMITS_MODULE_NAME);
export const getMyLimitsApiActions = createApiModuleActions('GET_MY_LIMITS');
export const myLimits = createFetchReducer(MY_LIMITS_MODULE_NAME, getMyLimitsApiActions[0], getMyLimitsApiActions[1], getMyLimitsApiActions[2]);
